import RestrictedRoute from './RestrictedRoute';

import Error404 from '../Pages/404';

import { LOGOUT } from 'adminConstants/routes';
import LogoutPage from '../Pages/Logout';

const CommonRoutes = [
  // eslint-disable-next-line react/jsx-key
  <RestrictedRoute component={LogoutPage} path={LOGOUT} />,
  // eslint-disable-next-line react/jsx-key
  <RestrictedRoute component={Error404} />,
];

export default CommonRoutes;
